import EditTimeSheets from "../../components/AllRecords/EditTimeSheets";

const DetailTimeSheets = () => {
  return (
    <>
      <EditTimeSheets />
    </>
  );
};

export default DetailTimeSheets;
